<ng-container *ngIf="galleryItems && galleryItems.length > 0">
    <div class="product-gallery">
        <div class="main-image" [ngClass]="productFinish ? 'product-finish' : 'product-fabric'">
            <div *ngIf="isSizeMd" class="flex justify-center items-center">
                <img [src]="galleryItems[selectedImageIndex].type === 'image'? galleryItems[selectedImageIndex].src: galleryItems[selectedImageIndex].poster"
                     (click)="openGallery(selectedImageIndex)"
                     class="cursor-pointer"
                     [alt]="galleryItems[selectedImageIndex].alt" />
            </div>

            <div *ngIf="!isSizeMd"
				 class="flex justify-center items-center"
                 fbSwipe
                 (next)="nextImage(selectedImageIndex)"
                 (previous)="prevImage(selectedImageIndex)"
                 >
                <img *ngIf="galleryItems[selectedImageIndex].type === 'image'"
                     [src]="galleryItems[selectedImageIndex].src"
                     (click)="openGallery(selectedImageIndex)"
                     class="cursor-pointer"
                     [alt]="galleryItems[selectedImageIndex].alt" />

                <img *ngIf="galleryItems[selectedImageIndex].type !== 'image'"
                     [src]="galleryItems[0].src"
                     (click)="openGallery(selectedImageIndex)"
                     class="cursor-pointer"
                     [alt]="galleryItems[selectedImageIndex].alt" />

                <img *ngIf="galleryItems[selectedImageIndex].type !== 'image'"
                     class="shorts-thumb"
                     src="assets/img/youtube_shorts_icon.svg" [alt]="galleryItems[selectedImageIndex].alt">
            </div>

            <div *ngIf="hasVideo"
                 (click)="openGallery(1)"
                 class="absolute bottom-5 left-5 w-10 h-10 rounded-full bg-[#FFFBF8] flex justify-center items-center cursor-pointer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5625 15.5156V8.48438C3.5625 7.98709 3.76004 7.51018 4.11167 7.15855C4.46331 6.80692 4.94022 6.60938 5.4375 6.60938H13.4062C13.9035 6.60938 14.3804 6.80692 14.7321 7.15855C15.0837 7.51018 15.2812 7.98709 15.2812 8.48438V15.5156C15.2812 16.0129 15.0837 16.4898 14.7321 16.8415C14.3804 17.1931 13.9035 17.3906 13.4062 17.3906H5.4375C4.94022 17.3906 4.46331 17.1931 4.11167 16.8415C3.76004 16.4898 3.5625 16.0129 3.5625 15.5156ZM19.6575 7.30406L15.9075 10.6444C15.8581 10.6883 15.8185 10.7421 15.7914 10.8024C15.7642 10.8626 15.7501 10.928 15.75 10.9941V12.6609C15.7501 12.727 15.7642 12.7924 15.7914 12.8526C15.8185 12.9129 15.8581 12.9667 15.9075 13.0106L19.6575 16.3509C19.7251 16.4109 19.8085 16.4501 19.8978 16.4638C19.9872 16.4775 20.0785 16.465 20.1609 16.428C20.2434 16.3909 20.3133 16.3309 20.3624 16.255C20.4114 16.1791 20.4375 16.0907 20.4375 16.0003V7.65469C20.4375 7.56433 20.4114 7.47589 20.3624 7.40002C20.3133 7.32414 20.2434 7.26407 20.1609 7.22702C20.0785 7.18998 19.9872 7.17754 19.8978 7.19121C19.8085 7.20487 19.7251 7.24407 19.6575 7.30406Z" stroke="#7D5A20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div (click)="openGallery(0)"
                 class="absolute bottom-5 right-5 w-10 md:w-auto h-10 rounded-full bg-[#FFFBF8] flex justify-center items-center gap-1 md:px-2 cursor-pointer">
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M2.8125 8.40278C2.8125 9.88541 3.40147 11.3073 4.44985 12.3557C5.49823 13.4041 6.92014 13.9931 8.40278 13.9931C9.88541 13.9931 11.3073 13.4041 12.3557 12.3557C13.4041 11.3073 13.9931 9.88541 13.9931 8.40278C13.9931 6.92014 13.4041 5.49823 12.3557 4.44985C11.3073 3.40147 9.88541 2.8125 8.40278 2.8125C6.92014 2.8125 5.49823 3.40147 4.44985 4.44985C3.40147 5.49823 2.8125 6.92014 2.8125 8.40278Z" stroke="#7D5A20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M17.1874 17.1875L12.3958 12.3959" stroke="#7D5A20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<span class="hidden md:block text-xs primary-brown-text">View Gallery</span>
            </div>
        </div>


        <div *ngIf="isSizeMd" class="thumbnail-wrapper ">
            <button *ngIf="showArrows"
                    class="arrow left cursor-pointer" (click)="scrollThumbnails('left')">&#8249;</button>

            <div class="thumbnails cursor-pointer"
                 [ngClass]="showArrows? 'thumbnails-arrow-padding': 'thumbnails-padding'"
                 #thumbnailContainer>
                <div *ngFor="let image of galleryItems;let i = index"
					 class="thumbnail-container relative flex-shrink-0"
					 [class.active]="i === selectedImageIndex">
                    <img [src]="image.type === 'image' ? image.thumb : image.poster"
                            (click)="selectImage(i)"
                            [alt]="image.alt"
                    />
                    <img *ngIf="image.type !== 'image'"
                         class="shorts-thumb"
                         src="assets/img/youtube_shorts_icon.svg" [alt]="image.alt">
                </div>
            </div>
            <button *ngIf="showArrows"
                    class="arrow right cursor-pointer" (click)="scrollThumbnails('right')">&#8250;</button>
        </div>

        <div *ngIf="!isSizeMd">
            <div class="circular-thumbnails cursor-pointer"
                 #thumbnailContainer>
                <div class="" *ngFor="let image of galleryItems;let i = index">
                   <div *ngIf="image.type === 'image'"
                        (click)="selectImage(i)"
                        class="circular-control"
                        [class.active]="i === selectedImageIndex"></div>
                   <div *ngIf="image.type !== 'image'"
                        (click)="selectImage(i)"
                        class="circular-control"
                        [class.active]="i === selectedImageIndex">
                       <div class="video-thumbnail"></div>
                   </div>
                </div>
            </div>
        </div>
    </div>

    <lightgallery
        #lightGallery
        [settings]="settings"
        [onInit]="onInit"
    >
    </lightgallery>
</ng-container>


